import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {ConfirmModal, TableLink, useNotifications} from "peggirkit";
import {EmployeeTimeEntry} from "@/data/entities/employee";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {SetStateFn} from "@/utils/SetStateUtils";
import {api} from "@/data/api";

type Props = {
    entry: EmployeeTimeEntry,
    setLastUpdated: SetStateFn<Date>,
};

const DeleteTimeEntry = ({entry, setLastUpdated}: Props) => {
    const intl = useIntl();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);
    const {mutate} = useMutation({
        mutationFn: (entryId: number) => api.timeEntry.deleteTimeEntry(entryId),
        onSuccess: () => {
            notifySuccess(intl.formatMessage({id: "timeRegistrationDeleted"}), notify)
            setLastUpdated(new Date());
        },
        onError: () => {
            notifyDanger(intl.formatMessage({id: "systemError"}), notify);
            setLoading(false);
        },
    });

    return (
        <>
            <TableLink
                color={"danger"}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setShowDeleteModal(true),
                    },
                }}
            >
                <FormattedMessage id={"delete"}/>
            </TableLink>

            <ConfirmModal
                type={"danger"}
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                title={intl.formatMessage({id: "deleteTimeRegistration"})}
                dismissButton={{
                    text: intl.formatMessage({id: "cancel"}),
                }}
                continueButton={{
                    text: intl.formatMessage({id: "continue"}),
                    onClick: () => {
                        setLoading(true);
                        mutate(entry.id)
                    },
                    props: {color: "danger"},
                }}
                disabled={loading}
                loading={loading}
                position={"center-bottom"}
                breakpoints={{md: {position: "center"}}}
            >
                <FormattedMessage id={"confirmDeleteTimeRegistration"}/>
            </ConfirmModal>
        </>
    );
};

export default DeleteTimeEntry;